import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-dropdown-select';
import { Controller } from 'react-hook-form';

import { convertKeysToCamelCase } from '../helpers/baseHelper';
import { REGISTER_GENDERS } from '../constants/login';
import style from '../assets/scss/components/RegisterForm.module.scss';
import useRegister from '../hooks/useRegister';
import TurnstileWidget from './common/TurnstileWidget';
import { Link } from 'react-router-dom';
import { LEGAL_NOTICE_PAGE } from '../constants/routes';
import { useSelector } from 'react-redux';

function RegisterForm() {
  const { t } = useTranslation();
  const modalWithRedirect = useSelector((state) => state.defaultReducer.modalWithRedirect);
  const {
    submitRegisterForm,
    isTermsChecked,
    setIsTermsChecked,
    isNewsletterChecked,
    setIsNewsletterChecked,
    selectedGender,
    setSelectedGender,
    control,
    register,
    handleSubmit,
    handleLegalNotice,
    errors,
    turnstileProps,
  } = useRegister(modalWithRedirect);

  const {
    form,
    formSmallInput,
    formLargeInput,
    formLabel,
    formError,
    formSelect,
    submitButton,
    termsWrapper,
    termsChecks,
    acceptance,
    turnstile,
    submitGroup,
  } = convertKeysToCamelCase(style);

  return (
    <form className={`${form} register-form`} onSubmit={handleSubmit(submitRegisterForm)}>
      <div className="">
        <div className={formSmallInput}>
          <span>
            <label className={formLabel}>{t('register.form.gender.label')} *</label>
            <Controller
              render={({ field: { onChange } }) => {
                return (
                  <Select
                    className={formSelect}
                    onChange={(values) => {
                      onChange(values);
                      setSelectedGender(values);
                    }}
                    options={REGISTER_GENDERS}
                    values={selectedGender || []}
                    placeholder={t('register.form.gender.placeholder')}
                  />
                );
              }}
              name="gender"
              control={control}
            />
            {errors?.gender && <div className={formError}>{t(`validation.${errors?.gender?.message}`)}</div>}
          </span>
          <span>
            <label className={formLabel}>{t('register.form.institute.label')} *</label>
            <input {...register('institute')} />
            {errors?.institute && <div className={formError}>{t(`validation.${errors?.institute?.message}`)}</div>}
          </span>
          <span>
            <label className={formLabel}>{t('register.form.firstName.label')} *</label>
            <input {...register('firstName')} />
            {errors?.firstName && <div className={formError}>{t(`validation.${errors?.firstName?.message}`)}</div>}
          </span>
          <span>
            <label className={formLabel}>{t('register.form.lastName.label')} *</label>
            <input {...register('lastName')} />
            {errors?.lastName && <div className={formError}>{t(`validation.${errors?.lastName?.message}`)}</div>}
          </span>
          <span>
            <label className={formLabel}>{t('register.form.postalCode.label')} *</label>
            <input {...register('postalCode')} />
            {errors?.postalCode && <div className={formError}>{t(`validation.${errors?.postalCode?.message}`)}</div>}
          </span>
          <span>
            <label className={formLabel}>{t('register.form.city.label')} *</label>
            <input {...register('city')} />
            {errors?.city && <div className={formError}>{t(`validation.${errors?.city?.message}`)}</div>}
          </span>
        </div>
        <div className={formLargeInput}>
          <label className={formLabel}>{t('register.form.email.label')} *</label>
          <input {...register('email')} />
          {errors?.email && <div className={formError}>{t(`validation.${errors?.email?.message}`)}</div>}
          <label className={formLabel}>{t('register.form.password.label')} *</label>
          <input {...register('password')} type="password" />
          {errors?.password && <div className={formError}>{t(`validation.${errors?.password?.message}`)}</div>}
          <label className={formLabel}>{t('register.form.password.confirm.label')} *</label>
          <input {...register('passwordConfirmation')} type="password" />
          {errors?.passwordConfirmation && (
            <div className={formError}>{t(`validation.${errors?.passwordConfirmation?.message}`)}</div>
          )}
        </div>

        <div className={termsWrapper}>
          <div className={termsChecks}>
            <div className={acceptance}>
              <input
                name="terms"
                type="checkbox"
                onChange={() => setIsTermsChecked(!isTermsChecked)}
                checked={isTermsChecked}
                value={isTermsChecked}
              />
              <span>
                {`${t('register.form.terms.label.1')} `}
                <Link onClick={handleLegalNotice} to={LEGAL_NOTICE_PAGE}>
                  AGB
                </Link>
                {` ${t('register.form.terms.label.2')}`}
              </span>
            </div>
            {!isTermsChecked && <div className={formError}>{t(`validation.required`)}</div>}
            <div className={acceptance}>
              <input
                {...register('newsletter')}
                type="checkbox"
                onChange={() => setIsNewsletterChecked(!isNewsletterChecked)}
                checked={isNewsletterChecked}
                value={isNewsletterChecked}
              />
              <span>{`${t('register.form.newsletter.label')} `}</span>
            </div>
          </div>

          <div className={submitGroup}>
            <TurnstileWidget {...turnstileProps} className={turnstile} />
            <button className={`${submitButton}`} type="submit">
              {t('general.buttons.register')}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default RegisterForm;
